(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["product-media"] && !Shopify.designMode) return;
  try {
    function hideProductMediaPreloaders(root) {
    const scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('.product-images-wrapper swiper-slide').forEach((slide) => {
      const preloader = slide.shadowRoot && slide.shadowRoot.querySelector('.swiper-lazy-preloader');
      if (!preloader) return;

      const images = slide.querySelectorAll('img');
      if (!images.length) {
        preloader.remove();
        return;
      }

      const loaded = Array.from(images).every((img) => img.complete);
      if (loaded) {
        preloader.remove();
        return;
      }

      images.forEach((img) => {
        img.addEventListener('load', () => preloader.remove(), { once: true });
        img.addEventListener('error', () => preloader.remove(), { once: true });
      });
    });
  }

  function initProductMediaPreloaders() {
    hideProductMediaPreloaders(document);
    document.addEventListener('shopify:section:load', (event) => {
      hideProductMediaPreloaders(event.target);
    });
  }

  if (window.customElements && customElements.whenDefined) {
    customElements.whenDefined('swiper-slide').then(initProductMediaPreloaders);
  } else if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initProductMediaPreloaders, { once: true });
  } else {
    initProductMediaPreloaders();
  }
  } catch(e) { console.error(e); }
})();

})();
